import installer from '@aspectus/vue-route-installer'
import { route } from '@md/routing'
import { accessPermission } from '@md/users/permissions'

const ComponentsInstaller = () => import('./components')
const Display = () => import('./views/Display')

const ROUTE_NAME = 'profile:map'
const ROUTE_NAME_BUYOUT = 'profile:map:buyout'

const withBuyout = r => ({ ...r.params, announcementType: 'buyout' })
const withAnnouncement = r => ({ ...r.params, announcementType: 'announcement' })

export function createRoutes(options) {
  const { Vue } = options
  return [
    route('', installer(Display, ComponentsInstaller, Vue), ROUTE_NAME, {
      props: withAnnouncement,
      meta: accessPermission(['ADS:ADS:VIEW'], options),
    }),
    route('buyout/', installer(Display, ComponentsInstaller, Vue), ROUTE_NAME_BUYOUT, {
      props: withBuyout,
      meta: accessPermission(['ADS:BUYOUT:VIEW'], options),
    }),
  ]
}
